import { render, staticRenderFns } from "./ListForm.vue?vue&type=template&id=dc0be9d2&scoped=true&"
import script from "./ListForm.vue?vue&type=script&lang=js&"
export * from "./ListForm.vue?vue&type=script&lang=js&"
import style0 from "./ListForm.vue?vue&type=style&index=0&id=dc0be9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0be9d2",
  null
  
)

export default component.exports